// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"7359ba3aade7b140195e","678":"a4cadb5b0b9098269860","883":"70e5e56811d694eff5e5"}[chunkId] + ".js";
};